import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroVideoCarousel from '../sections/HeroVideoCarousel';
import Hero from '../sections/Hero';
import ContextModel from '../sections/ContextModel';
import Solutions from '../sections/Solutions';
import Services from '../sections/Services';
// import SuccessStories from '../sections/SuccessStories'; // TEMPORARILY HIDDEN — re-enable when customer content is ready
import Insights from '../sections/Insights';
import CTA from '../sections/CTA';

const Home = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <main>
        <HeroVideoCarousel />
        <Hero />
        <ContextModel />
        <Solutions />
        <Services />
        {/* <SuccessStories /> */} {/* TEMPORARILY HIDDEN — re-enable when customer content is ready */}
        <Insights />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
